import SectionInput from './SectionInput';

export default SectionInput;
